import React, {CSSProperties, useEffect, useRef, useState} from "react";
import {Vector2} from "@utility/vector2";
import {Bounds2} from "@utility/bounds2";

const styles: Record<string, CSSProperties> = {
    content: {
        display: "flex",
        flexGrow: 1
    },
    highlight: {
        boxShadow: "0 0 8px white",
        backgroundColor: "white",
        borderRadius: 4,
        padding: 2
    }
};

interface ITileSlotInsert {
    dragPosition: Vector2
    setInsert: (insert: number) => void
    side: "left"|"right"
    slot: number
}

export function TileSlotInsert({dragPosition, setInsert, side, slot}: ITileSlotInsert) {
    const [bounds, setBounds] = useState(Bounds2.zeroEmpty);
    const slotRef = useRef<HTMLDivElement>(null);
    const highlightStyle: CSSProperties = {
        ...styles.highlight,
        display: bounds.contains(dragPosition) ? "block" : "none"
    }

    useEffect(() => {
        if (bounds.contains(dragPosition)) {
            setInsert(slot);
        }
    }, [bounds, dragPosition]);
    useEffect(() => {
        if (slotRef.current) {
            setBounds(new Bounds2(slotRef.current?.getBoundingClientRect()));
        }
    }, [slotRef, slot]);
    return (
        <div ref={slotRef} style={{...styles.content, justifyContent: side === "left" ? "flex-start" : "flex-end"}}>
            <div style={highlightStyle}/>
        </div>
    );
}